// 类目属性组件的一些辅助工具

const needVoidPropertyName = ['品牌']; // 需要添加空值的一些字段
const clothingCategoryNames = ['女装','男装','童装/婴儿装/亲子装', '运动服/休闲服装','内衣裤袜']  // 服饰类类目
/**
 * 给一些字段添加一些空值选项
 * @param {*} item 
 */
export function genVoidOption(item) {
    if (needVoidPropertyName.includes(item.propertyName)) {
        item.options.unshift({
            name: `无${item.propertyName}`,
            value: ""
        })
        return item.propertyId
    }
    return false
}

/**
 * 生成必填校验方法
 * @param {*} item 
 * @returns 
 */
export function genReqiuredRule(item, text) {
    const errormsg = text + item.propertyName;
    return (rule, value, cb) => {
        if (needVoidPropertyName.includes(item.propertyName) && value === "") {
            return cb()
        }
        if (value instanceof Array && !value.length) {
            return cb(new Error(errormsg))
        }
        if (!value) {
            return cb(new Error(errormsg))
        }
        cb()
    }
}
export function genClothingsRule(item, self_form) {
    const rules = []
    const options = item.options || []
    if (item.required) {
        rules.push({ required: true, message: `必填` })
    }

    rules.push({
        validator: (rule, value, cb) => {
            const categoryNames = self_form.categoryNames || []
            const name = self_form.name || ''
            const isYuRong = categoryNames?.length && 
                clothingCategoryNames.includes(categoryNames[0]) && 
                (categoryNames.includes('羽绒') || name.includes('羽绒'))
            
            if(isYuRong && (!value || (Array.isArray(value) && !value.length))) {
                return cb(new Error(`必填`))
            }
            // 非羽绒类目或值为空时不校验
            if (!isYuRong || !value || (Array.isArray(value) && !value.length)) {
                return cb()
            }

            // 统一转为数组处理
            const values = Array.isArray(value) ? value : [value]
            
            // 辅助函数：获取选项名称
            const getValueName = (v) => options.find(o => o.value === v)?.name || v || ''

            if(item.propertyName === '填充物种类') {
                // 只要有一个包含 '绒' 即可
                const isMatch = values.some(v => String(getValueName(v)).includes('绒'))
                if(!isMatch) {
                    return cb(new Error(`填充物必须填写羽绒`))
                }
            }
            
            if(item.propertyName === '绒子含量') {
                // 只要有一个 >= 50 即可
                const isMatch = values.some(v => {
                    const num = parseFloat(String(getValueName(v)).replace(/[^\d.]/g, ''))
                    return !isNaN(num) && num >= 50
                })
                if(!isMatch) {
                    return cb(new Error(`绒子含量需≥50%`))
                }
            }
            // checkPropertyPics(cb,item,self_form.categoryPropertyPics);
            cb()
        }
    })
    return rules
}

/**
 * 多模块度量衡校验方法
 * @param {*} item 
 * @returns 
 */
export function genMutilMeasureRule(item, formMeasureData, isRequire, self_form,params={}) {
    return (rule, value, cb) => {
        value = formMeasureData[item.propertyId]
        if(isRequire && !value?.length){
            return cb(new Error(`请添加${item.propertyName}`))
        } else if(value?.length && item.type === 'multi_value_measure') {
            let total = 0
            let valueNameList = []
            let errorMsg = ''
            const categoryNames = self_form.categoryNames || []
            const name = self_form.name || ''
            const isClothing = clothingCategoryNames.includes(categoryNames[0])
            const isYangClass = ['羊毛', '羊绒'].some(v => categoryNames.some(c => c.includes(v)))
            let yangValueTotal = 0
            value.forEach(m => {
                let unitValue = 0
                let valueName = ''
                m.measure_info.values.forEach(v => {
                    if(v.unit_name == '%' && v.value) {
                        unitValue = Number(v.value) * 1000
                        total += unitValue
                    } else {
                       valueName = v.value
                        if(valueNameList.includes(valueName)) {
                            errorMsg = '材质不能重复'
                            return
                        }
                        valueNameList.push(valueName)
                    }
                })
                // 服饰类目, 其他材质含量需<=15%
                if(isClothing && item.propertyName === "面料材质") {
                    if(valueName === '其他' && unitValue > 15 * 1000) {
                        errorMsg = '其他材质含量需<=15%'
                        return
                    } 
                    if(isYangClass && ['羊毛', '羊绒'].some(v => valueName.includes(v)) ) {
                        yangValueTotal += unitValue
                    }
                }
            });
            if(errorMsg) {
                return cb(new Error(errorMsg))
            }
            if(total !== 100 * 1000) {
                return cb(new Error('输入的百分比之和必须等于100'))
            }
            // 类目为“羊毛/羊绒”相关类目，面料材质必须填写“羊绒/羊毛”，且含量必须≥30%
            if(isClothing && item.propertyName === "面料材质" && isYangClass) {
                const hasWoolOrCotton = ['羊毛', '羊绒'].some(v => valueNameList.some(n => n.includes(v)))
                if(!hasWoolOrCotton) {
                    return cb(new Error('必须填写“羊毛/羊绒”'))
                } else if(yangValueTotal < 30 * 1000) {
                    return cb(new Error('“羊毛/羊绒”含量必须≥30%'))
                } else if((name.includes('100%羊绒') || name.includes('全羊毛')) && yangValueTotal < 95 * 1000) { 
                    // 若标题/主图含“100%羊绒/全羊毛”等信息，“羊绒/羊毛”含量需≥95%
                    return cb(new Error('“羊毛/羊绒”含量需≥95%'))
                }
            }
            if(params?._this?.propertyPics){
                checkPropertyPics(cb,item,params?._this?.propertyPics);
            }
        }
        cb()
    }
}

/**
 * 营养成分校验
 * @param {*} item
 * @returns
 */
export function genNutritionRule(item, formMeasureData, isRequire) {
    return (rule, value, cb) => {
        value = formMeasureData[item.propertyId];
        if (isRequire && !value?.length) {
            return cb(new Error(`请添加${item.propertyName}`));
        }
        // 检查必填项是否都填写了
        if (value?.length) {
            const templateData = value.find(v => v.measure_info);
            if (templateData?.measure_info) {
                const measureTemplates = item.measureTemplates || [];
                const valueModules = measureTemplates[0]?.valueModules || [];
                const requiredModules = valueModules.filter(m => m.valueRequired);
                const values = templateData.measure_info.values || [];
                for (const rm of requiredModules) {
                    const matched = values.find(v => v.module_id === rm.moduleId);
                    if (!matched || !matched.value) {
                        return cb(new Error(`${rm.prefix}为必填项`));
                    }
                }
            }
        }
        cb();
    };
}

function checkPropertyPics(cb,item,categoryPropertyPics={}){
    if(item.propertyPicRequired === 1){
        let value = categoryPropertyPics[item.propertyId]
        if(!value || value.length === 0){
            return cb(new Error('请上传图片'))
        }
    }
}